export interface ChatContact {
  id: string;
  email: string;
  groupName: string;
  firstName: string;
  lastName: string;
  userAvatar: string;
  lastMessage: string;
  lastMessageSender: string;
  lastMsgDate: string;
  unReadCount: number;
  isAGroup: boolean;
  isPinned: boolean;
  isMarkFavourite: boolean;
  lastSeen: string;
  isOnline: boolean;
  deliveredDate: string | null;
  isRead: boolean;
  isBlockedByMe?: boolean;
  hasBlockedMe?: boolean;
  canSendMessage?: boolean;
  // Legacy fields for backward compatibility
  name?: string;
  title?: string;
  avatar?: string;
  lastMessageTime?: string;
  unreadCount?: number;
}

export interface Message {
  id: string;
  msgId?: string;
  parentMessageId?: string;
  parentMsgId?: string;
  creatorId?: string;
  recipientUserId?: string;
  type: string;
  messageBody?: string;
  docData?: string | null;
  compressedDocData?: string | null;
  createdDate?: string;
  userName?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  userAvatar?: string;
  parentMsgDta?: any | null;
  deliveredDate?: string | null;
  isOnline?: boolean;
  isRead?: boolean;
  // Additional fields for UI compatibility
  text?: string; // For backward compatibility
  timestamp?: string; // For backward compatibility
  isFromUser?: boolean; // For backward compatibility
  isFromSignalR?: boolean; // Flag to identify messages received via SignalR
  imageUrl?: string; // For backward compatibility
}

export interface FilterOption {
  label: string;
  value: string;
}

export interface TabOption {
  id: string;
  label: string;
  icon: string;
}

export enum ChatStatus {
  UnRead = "UnRead",
  Favourites = "Favourites",
  Pinned = "Pinned",
  Blocked = "Blocked"
}

export interface ChatSummaryRequest {
  pageNumber: number;
  pageSize: number;
  searchQuery: string;
  status: ChatStatus[];
}

/** GetUserChatSummary `data` payload (pinned + unpinned arrays). */
export interface ChatSummaryData {
  pinnedChats: ChatContact[];
  unPinnedChats: ChatContact[];
}

/** Request body for Pin / UnPin chat APIs (`recipientId` matches `id` from GetUserChatSummary). */
export interface PinChatRequest {
  recipientId: string;
  groupId: string;
}

export enum BlockReasonId {
  Spam = 1,
  Harassment = 2,
  InappropriateContent = 3,
  FakeProfile = 4,
  ScamOrFraud = 5,
  HateSpeech = 6,
  Other = 7
}

export interface BlockReasonOption {
  id: number;
  code: string;
  title: string;
  description: string;
  displayOrder: number;
  requiresComment: boolean;
}

export interface BlockUserRequest {
  recipientId: string;
  blockReasonId: number;
  reportComment: string | null;
}

export interface UnBlockUserRequest {
  recipientId: string;
}

export interface ChatBlockFlags {
  isBlockedByMe: boolean;
  hasBlockedMe: boolean;
  canSendMessage: boolean;
}

export interface ChatBlockStatus extends ChatBlockFlags {
  recipientId: string;
  blockReasonId?: number | null;
}

export interface MessageBlockedPayload {
  recipientId: string;
  canSendMessage: boolean;
  message: string;
} 